module.exports = __webpack_public_path__ + "img/stores_personal_consultation@2x.2126541.jpg";